(function () {
  "use strict";

  var PRODUCT_ID_FALLBACK = 8128541130809;

  function readConfig(root) {
    var el = root.querySelector("[data-transit-protection-config]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: currency || "AUD",
      }).format(cents / 100);
    } catch (err) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  function findLines(cart, productId) {
    if (!cart || !cart.items) return [];
    return cart.items.filter(function (item) {
      return item.product_id === productId;
    });
  }

  function transitQty(lines) {
    return lines.reduce(function (sum, item) {
      return sum + item.quantity;
    }, 0);
  }

  function goodsCount(cart, productId) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (sum, item) {
      return item.product_id === productId ? sum : sum + item.quantity;
    }, 0);
  }

  function updateWidgets(cart, config) {
    var productId = config.productId || PRODUCT_ID_FALLBACK;
    var lines = findLines(cart, productId);
    var line = lines[0] || null;
    var on = transitQty(lines) > 0;
    var hasGoods = goodsCount(cart, productId) > 0;

    document.querySelectorAll("[data-transit-protection]").forEach(function (root) {
      if (!hasGoods) {
        root.hidden = true;
        return;
      }
      root.hidden = false;
      root.classList.toggle("is-on", on);
      root.classList.remove("is-loading");
      var toggle = root.querySelector("[data-transit-protection-toggle]");
      var onCopy = root.querySelector("[data-transit-on-copy]");
      var offCopy = root.querySelector("[data-transit-off-copy]");
      if (toggle) {
        toggle.checked = on;
        toggle.disabled = false;
      }
      if (onCopy) onCopy.hidden = !on;
      if (offCopy) offCopy.hidden = on;
      var cfgEl = root.querySelector("[data-transit-protection-config]");
      if (cfgEl && line) {
        try {
          var next = JSON.parse(cfgEl.textContent);
          next.lineKey = line.key;
          cfgEl.textContent = JSON.stringify(next);
        } catch (err) {}
      }
    });

    document.querySelectorAll("[data-cart-prices] .t4s-cart__totalPrice").forEach(function (el) {
      el.textContent = formatMoney(cart.total_price, config.currency);
    });

    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = String(goodsCount(cart, productId));
    });
  }

  function postJson(url, body) {
    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || data.message || "Cart update failed");
        });
      }
      return res.json();
    });
  }

  function getCart(config) {
    return fetch(config.cartUrl, {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    }).then(function (res) { return res.json(); });
  }

  function removeAllTransit(config, lines) {
    if (!lines.length) return Promise.resolve();
    var updates = {};
    lines.forEach(function (line) {
      updates[line.key] = 0;
    });
    return postJson(config.updateUrl || "/cart/update.js", { updates: updates });
  }

  function addTransit(config) {
    return postJson(config.addUrl, {
      items: [{
        id: config.variantId,
        quantity: 1,
        properties: { _transit_protection: "true" },
      }],
    });
  }

  function setTransit(cart, config, wantOn) {
    var lines = findLines(cart, config.productId);
    var qty = transitQty(lines);

    if (!wantOn) {
      if (!lines.length) return Promise.resolve(cart);
      return removeAllTransit(config, lines).then(function () {
        return getCart(config);
      });
    }

    if (qty === 1 && lines.length === 1) return Promise.resolve(cart);

    return removeAllTransit(config, lines).then(function () {
      return addTransit(config);
    }).then(function () {
      return getCart(config);
    });
  }

  function setLoading(root, loading) {
    root.classList.toggle("is-loading", loading);
    var toggle = root.querySelector("[data-transit-protection-toggle]");
    if (toggle) toggle.disabled = loading;
  }

  function handleToggle(root, checked) {
    var config = readConfig(root);
    if (!config || !config.variantId) return;

    setLoading(root, true);

    getCart(config)
      .then(function (cart) {
        return setTransit(cart, config, checked);
      })
      .then(function (cart) {
        return cleanupCart(cart, config);
      })
      .then(function (next) {
        updateWidgets(next, config);
      })
      .catch(function (err) {
        var toggle = root.querySelector("[data-transit-protection-toggle]");
        if (toggle) toggle.checked = !checked;
        setLoading(root, false);
        console.warn("Transit protection:", err.message || err);
      });
  }

  function cleanupCart(cart, config) {
    var lines = findLines(cart, config.productId);
    var qty = transitQty(lines);

    if (goodsCount(cart, config.productId) === 0) {
      return setTransit(cart, config, false);
    }

    if (qty > 1 || lines.length > 1) {
      return setTransit(cart, config, true);
    }

    return Promise.resolve(cart);
  }

  document.addEventListener("change", function (event) {
    var toggle = event.target.closest("[data-transit-protection-toggle]");
    if (!toggle) return;
    var root = toggle.closest("[data-transit-protection]");
    if (!root) return;
    handleToggle(root, toggle.checked);
  });

  function syncFromCart() {
    var root = document.querySelector("[data-transit-protection]");
    if (!root) return;
    var config = readConfig(root);
    if (!config) return;
    getCart(config).then(function (cart) {
      return cleanupCart(cart, config);
    }).then(function (next) {
      updateWidgets(next, config);
    });
  }

  function observeCart() {
    var targets = document.querySelectorAll("[data-cart-count], [data-cart-items]");
    if (!targets.length || typeof MutationObserver === "undefined") return;
    var timer;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(syncFromCart, 250);
    });
    targets.forEach(function (el) {
      observer.observe(el, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      syncFromCart();
      observeCart();
    });
  } else {
    syncFromCart();
    observeCart();
  }
})();
